<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 137.55 145.87" style="enable-background:new 0 0 137.55 145.87;" xml:space="preserve">
        <rect x="6.83" y="6.19" class="st0" width="124.32" height="25.76"/>
        <rect x="6.83" y="31.95" class="st0" width="124.32" height="107.75"/>
        <rect x="78.62" y="52.29" class="st1" width="32.9" height="25.53"/>
        <rect x="78.62" y="93.65" class="st1" width="32.9" height="25.53"/>
        <rect x="26.55" y="52.29" class="st1" width="32.9" height="25.53"/>
        <rect x="26.55" y="93.65" class="st1" width="32.9" height="25.53"/>
    </svg>

</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .st0{fill:none;stroke:#000000;stroke-width:7;stroke-miterlimit:10;}
    .st1{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}
</style>